import React, { useRef } from "react";
import FormWizard from "react-form-wizard-component";
import { Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";

import { useInitialDataImplementation } from "@/hooks/implementation/firstLoad/initialDataImplementation";

import BusinessTableLoad from "./Components/BusinessTableLoad";
import EstateParentsTableLoad from "./Components/EstateParentsTableLoad";
import EstatesTableLoad from "./Components/EstatesTableLoad";
import UsersTableLoad from "./Components/UsersTableLoad";
import BusinessCenterParentTableLoad from "./Components/BusinessCenterParentTableLoad";
import BusinessCenterTableLoad from "./Components/BusinessCenterTableLoad";
import ProductLoader from "./ProductLoader";
import ErrorDivContainer from "@/components/ErrorMessage";
import BalanceTableLoad from "./Components/BalanceTableLoad";

import "react-form-wizard-component/dist/style.css";
import "./Components/rowsLoadStyle.scss";

const components = {
	BusinessTableLoad: <BusinessTableLoad />,
	EstateParentsTableLoad: <EstateParentsTableLoad />,
	EstatesTableLoad: <EstatesTableLoad />,
	UsersTableLoad: <UsersTableLoad />,
	BusinessCenterParentsTableLoad: <BusinessCenterParentTableLoad />,
	BusinessCentersTableLoad: <BusinessCenterTableLoad />,
	BalancesTableLoad: <BalanceTableLoad />,
	ProductsLoader: <ProductLoader />,
};

export default function LoadInventory() {
	const formWizardRef = useRef(null);
	const { customer } = useSelector((state) => state.auth.user);
	const { estate_parent_id, estate_id } = useSelector((state) => state.auth.filter);

	const { data: response, error, isLoading, isFetching } = useInitialDataImplementation({ estate_parent_id, estate_id });

	if (error) {
		return <ErrorDivContainer />;
	}

	if (response?.isComplete) {
		return <ProductLoader />;
	}

	if (isLoading || isFetching) {
		return (
			<div className="loading-spinner">
				<Spinner animation="border" role="status">
					<span className="sr-only">Cargando...</span>
				</Spinner>
			</div>
		);
	}

	return (
		<>
			<FormWizard startIndex={response ? response.implementationStep - 1 : 0} ref={formWizardRef} color="#7fb02f">
				{response?.implementation_steps.map((step, index) => {
					let stepName = step.name;
					if (step.name === "Bodegas" && !customer.use_estates_parents) {
						stepName = "Campos";
					}

					const componentProps = { ...step, index: index, formWizardRef };

					return (
						<FormWizard.TabContent key={index} title={stepName} icon={step.icon} isValid={true}>
							{React.cloneElement(components[step.component], componentProps)}
						</FormWizard.TabContent>
					);
				})}
			</FormWizard>

			<style>
				{`@import url("https://cdn.jsdelivr.net/gh/lykmapipo/themify-icons@0.1.2/css/themify-icons.css");`}
				{`@import url("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.2/css/all.min.css");`}
			</style>
		</>
	);
}
